import { useContext, useEffect, useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import {routes} from "../helpers/Routes";


const ProtectedRoute = () => {



  if (cargando) {
    // Puedes mostrar un indicador de carga aquí si lo deseas
    return <div>Cargando...</div>;
  }

  return <Navigate to={routes.login} />
};

export default ProtectedRoute;